module.exports = __webpack_public_path__ + "static/media/Mohannad Salam.afabb0b7.png";